import { Box } from '@wix/design-system';
import React from 'react';
import { ProductCardSkeleton } from './ProductCard/ProductCardSkeleton';

const DEFAULT_CARD_COUNT = 5;

interface ProductCardsSkeletonProps {
  overrideCardCount?: number;
}

export const ProductCardsSkeleton = ({
  overrideCardCount,
}: ProductCardsSkeletonProps) => {
  const cardCount = overrideCardCount ?? DEFAULT_CARD_COUNT;
  return (
    <Box
      direction="horizontal"
      width="100%"
      maxWidth="1140px"
      gap="SP3"
      padding="0 12px"
      align="center"
      marginTop="SP8"
    >
      {Array.from({ length: cardCount }, (_, cardIndex) => (
        <ProductCardSkeleton key={cardIndex} cardIndex={cardIndex} />
      ))}
    </Box>
  );
};
